const trustPoints = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Printed in Starkville, MS',
    desc: 'Every shirt is printed right here in Starkville. Local jobs, local pride, local quality.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Fast Turnaround',
    desc: 'Most orders are printed and ready within 2–3 business days. No waiting weeks for your gear.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Guaranteed',
    desc: 'We stand behind every print. If you\'re not happy, we\'ll make it right — no questions asked.',
  },
  {
    icon: 'ri-group-line',
    title: 'Bulldogs Community',
    desc: 'We\'re fans too. Built by Starkville locals who bleed maroon and white every game day.',
  },
];

export function LocalTrustSection() {
  return (
    <section className="py-24 px-6 bg-[#6B0000] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/9defe4011b35fd456a3d5e09c2f6b7c8.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-white/20 text-white text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            Why On Target Prints
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Printed Locally in Starkville
          </h2>
          <p className="text-lg text-white/80 max-w-xl mx-auto">
            We're not a faceless online warehouse. We're your neighbors — printing Bulldogs gear with care, right here in town.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustPoints.map((point, i) => (
            <div
              key={i}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 hover:bg-white/20 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 group-hover:bg-white/30 transition-colors">
                <i className={`${point.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-black text-white mb-2">{point.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { value: '2,400+', label: 'Shirts Printed' },
            { value: '4.9★', label: 'Average Rating' },
            { value: '48hr', label: 'Avg. Turnaround' },
            { value: '100%', label: 'Local Production' },
          ].map((stat, i) => (
            <div key={i} className="bg-white/10 rounded-xl py-6 px-4 border border-white/20">
              <div className="text-3xl font-black text-white mb-1">{stat.value}</div>
              <div className="text-white/60 text-sm font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
